"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.recording.active': 'Grabación Activa',
    'conversation.recording.inactive': 'Grabación Inactiva',
};
